import PropTypes from 'prop-types';
import React from 'react';
import { FontIcon, Input } from 'react-toolbox';
import FlexBox from 'flexbox-react';
import cx from 'classnames';
import JobHistoryExcelSheet from './JobHistoryExcelSheet';
import styles from 'styles/contentArea';
import formStyles from 'styles/form';

const SMALL_INPUT = cx(formStyles.inputs, formStyles.mediumInput, styles.actionInput);

const JobHistoryHeader = ({ renderExcel, setRenderExcel, appts, search, setSearch }) =>
  (<FlexBox className={styles.contentAreaActions}>
    <div className={styles.leftActions}>
      <FontIcon value="search" />
      <Input
        className={SMALL_INPUT}
        value={search}
        onChange={setSearch}
      />
    </div>
    <div className={styles.rightActions}>
      {renderExcel ? (<JobHistoryExcelSheet
        appts={appts} unmountExcelSheet={() => setRenderExcel(false)}
      />) : null}
      <button onClick={() => setRenderExcel(true)} className={styles.titleAction}>
        <FontIcon value="get_app" />
      </button>
    </div>
  </FlexBox>);

JobHistoryHeader.propTypes = {
  renderExcel: PropTypes.bool.isRequired,
  setRenderExcel: PropTypes.func.isRequired,
  appts: PropTypes.array.isRequired,
  search: PropTypes.string.isRequired,
  setSearch: PropTypes.func.isRequired,
};

export default JobHistoryHeader;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/reports/jobHistory/components/JobHistoryHeader.jsx